"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildAppUpdatePaletteColorsActionAction = exports.buildAppUpdateRouteStackAction = exports.buildAppUpdateDbCacheAction = exports.buildAppUpdateControlPropByPathIfExistAction = exports.buildAppSetTransitionSideMenuAction = exports.buildAppSetIsSideMenuOpenedAction = exports.buildAppSetIsLoadingPageOpenedAction = exports.buildAppSetIsBottomMenuOpenedAction = exports.buildAppUpdateConfirmAlertContextAction = exports.buildAppUpdateAlertContextAction = exports.buildAppUpdateInputdialogContextAction = exports.buildAppOpenImageViewer = exports.buildAppOpenCameraAction = exports.buildAppUpdateAdmobInterstitialContextAction = exports.buildAppBootLocalStorageAction = exports.buildAppOverwriteDbCacheAction = exports.buildAppCleanLocalStorageListenersAction = exports.buildAppAddItemsToFlatListAction = exports.buildAppUpdateControlByIdAction = exports.buildAppUpdateSwiperContentAction = exports.buildAppUpdateControlToListAction = exports.buildAppAddLocalStorageListenerAction = exports.buildAppUpdateLocalStorageAction = exports.buildAppCleanLocalStorageAction = exports.buildAppUpdateRunningModeAction = exports.buildAppSetCustomFontNameAction = exports.buildAppResetAction = exports.buildAppBootAction = void 0;
const applicationStateConstants_1 = __importDefault(require("../shared/applicationStateConstants"));
const buildAppBootAction = (payload) => ({
    type: applicationStateConstants_1.default.BOOT,
    payload,
});
exports.buildAppBootAction = buildAppBootAction;
const buildAppResetAction = () => ({ type: applicationStateConstants_1.default.RESET });
exports.buildAppResetAction = buildAppResetAction;
const buildAppSetCustomFontNameAction = (payload) => ({
    type: applicationStateConstants_1.default.SET_CUSTOM_FONT_NAME,
    payload,
});
exports.buildAppSetCustomFontNameAction = buildAppSetCustomFontNameAction;
const buildAppUpdateRunningModeAction = (payload) => ({
    type: applicationStateConstants_1.default.UPDATE_RUNNING_MODE,
    payload,
});
exports.buildAppUpdateRunningModeAction = buildAppUpdateRunningModeAction;
const buildAppCleanLocalStorageAction = () => ({
    type: applicationStateConstants_1.default.CLEAN_LOCAL_STORAGE,
});
exports.buildAppCleanLocalStorageAction = buildAppCleanLocalStorageAction;
const buildAppUpdateLocalStorageAction = (payload) => ({
    type: applicationStateConstants_1.default.UPDATE_LOCAL_STORAGE,
    payload,
});
exports.buildAppUpdateLocalStorageAction = buildAppUpdateLocalStorageAction;
const buildAppAddLocalStorageListenerAction = (payload) => ({
    type: applicationStateConstants_1.default.ADD_LOCAL_STORAGE_LISTENER,
    payload,
});
exports.buildAppAddLocalStorageListenerAction = buildAppAddLocalStorageListenerAction;
const buildAppUpdateControlToListAction = (payload) => ({
    type: applicationStateConstants_1.default.UPDATE_CONTROL_TO_LIST,
    payload,
});
exports.buildAppUpdateControlToListAction = buildAppUpdateControlToListAction;
const buildAppUpdateSwiperContentAction = (payload) => ({
    type: applicationStateConstants_1.default.UPDATE_SWIPER_CONTENT,
    payload,
});
exports.buildAppUpdateSwiperContentAction = buildAppUpdateSwiperContentAction;
const buildAppUpdateControlByIdAction = (payload) => ({
    type: applicationStateConstants_1.default.UPDATE_CONTROL_BY_ID,
    payload,
});
exports.buildAppUpdateControlByIdAction = buildAppUpdateControlByIdAction;
const buildAppAddItemsToFlatListAction = (payload) => ({
    type: applicationStateConstants_1.default.ADD_ITEMS_TO_FLAT_LIST,
    payload,
});
exports.buildAppAddItemsToFlatListAction = buildAppAddItemsToFlatListAction;
const buildAppCleanLocalStorageListenersAction = () => ({
    type: applicationStateConstants_1.default.CLEAN_LOCAL_STORAGE_LISTENERS,
});
exports.buildAppCleanLocalStorageListenersAction = buildAppCleanLocalStorageListenersAction;
const buildAppOverwriteDbCacheAction = (payload) => ({
    type: applicationStateConstants_1.default.OVERWRITE_DB_CACHE,
    payload,
});
exports.buildAppOverwriteDbCacheAction = buildAppOverwriteDbCacheAction;
const buildAppBootLocalStorageAction = (payload) => ({
    type: applicationStateConstants_1.default.BOOT_LOCAL_STORAGE,
    payload,
});
exports.buildAppBootLocalStorageAction = buildAppBootLocalStorageAction;
const buildAppUpdateAdmobInterstitialContextAction = (payload) => ({
    type: applicationStateConstants_1.default.UPDATE_ADMOB_INTERSTITIAL_CONTEXT,
    payload,
});
exports.buildAppUpdateAdmobInterstitialContextAction = buildAppUpdateAdmobInterstitialContextAction;
const buildAppOpenCameraAction = (payload) => ({
    type: applicationStateConstants_1.default.OPEN_CAMERA,
    payload,
});
exports.buildAppOpenCameraAction = buildAppOpenCameraAction;
const buildAppOpenImageViewer = (payload) => ({
    type: applicationStateConstants_1.default.OPEN_IMAGE_VIEWER,
    payload,
});
exports.buildAppOpenImageViewer = buildAppOpenImageViewer;
const buildAppUpdateInputdialogContextAction = (payload) => ({
    type: applicationStateConstants_1.default.UPDATE_INPUTDIALOG_CONTEXT,
    payload,
});
exports.buildAppUpdateInputdialogContextAction = buildAppUpdateInputdialogContextAction;
const buildAppUpdateAlertContextAction = (payload) => ({
    type: applicationStateConstants_1.default.UPDATE_ALERT_CONTEXT,
    payload,
});
exports.buildAppUpdateAlertContextAction = buildAppUpdateAlertContextAction;
const buildAppUpdateConfirmAlertContextAction = (payload) => ({
    type: applicationStateConstants_1.default.UPDATE_CONFIRM_ALERT_CONTEXT,
    payload,
});
exports.buildAppUpdateConfirmAlertContextAction = buildAppUpdateConfirmAlertContextAction;
const buildAppSetIsBottomMenuOpenedAction = (payload) => ({
    type: applicationStateConstants_1.default.SET_IS_BOTTOM_MENU_OPENED,
    payload,
});
exports.buildAppSetIsBottomMenuOpenedAction = buildAppSetIsBottomMenuOpenedAction;
const buildAppSetIsLoadingPageOpenedAction = (payload) => ({
    type: applicationStateConstants_1.default.SET_IS_LOADING_PAGE_OPENED,
    payload,
});
exports.buildAppSetIsLoadingPageOpenedAction = buildAppSetIsLoadingPageOpenedAction;
const buildAppSetIsSideMenuOpenedAction = (payload) => ({
    type: applicationStateConstants_1.default.SET_IS_SIDE_MENU_OPENED,
    payload,
});
exports.buildAppSetIsSideMenuOpenedAction = buildAppSetIsSideMenuOpenedAction;
const buildAppSetTransitionSideMenuAction = (payload) => ({
    type: applicationStateConstants_1.default.SET_TRANSITION_SIDE_MENU,
    payload,
});
exports.buildAppSetTransitionSideMenuAction = buildAppSetTransitionSideMenuAction;
const buildAppUpdateControlPropByPathIfExistAction = (payload) => ({
    type: applicationStateConstants_1.default.UPDATE_CONTROL_PROP_BY_PATH_IF_EXIST,
    payload,
});
exports.buildAppUpdateControlPropByPathIfExistAction = buildAppUpdateControlPropByPathIfExistAction;
const buildAppUpdateDbCacheAction = (payload) => ({
    type: applicationStateConstants_1.default.UPDATE_DB_CACHE,
    payload,
});
exports.buildAppUpdateDbCacheAction = buildAppUpdateDbCacheAction;
const buildAppUpdateRouteStackAction = (payload) => ({
    type: applicationStateConstants_1.default.ROUTING_SET_STACK,
    payload,
});
exports.buildAppUpdateRouteStackAction = buildAppUpdateRouteStackAction;
const buildAppUpdatePaletteColorsActionAction = (payload) => ({
    type: applicationStateConstants_1.default.UPDATE_PALETTE_COLORS,
    payload,
});
exports.buildAppUpdatePaletteColorsActionAction = buildAppUpdatePaletteColorsActionAction;
